(() => {
  'use strict';
  const init = () => {
    document.querySelectorAll('[data-ss-site-header]:not([data-ss-ready])').forEach(header => {
      header.dataset.ssReady = 'true';
      const toggle = header.querySelector('.ss-site-menu-toggle');
      const menu = header.querySelector('.ss-site-mobile-menu');
      const close = (focus = false) => {
        const wasOpen = !menu.hidden;
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        if (focus && wasOpen) toggle.focus({preventScroll:true});
      };
      toggle.addEventListener('click', () => {
        const open = menu.hidden;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close()));
      document.addEventListener('keydown', event => {if (event.key === 'Escape') close(true);});
      document.addEventListener('click', event => {if (!header.contains(event.target)) close();});
      document.addEventListener('ss:close-menu', () => close());
      matchMedia('(min-width:750px)').addEventListener('change', event => {if (event.matches) close();});
    });
    document.querySelectorAll('[data-ss-section-nav]:not([data-ss-ready])').forEach(nav => {
      nav.dataset.ssReady='true';
      const links=[...nav.querySelectorAll('a[href^="#"]')];
      const select=chosen=>links.forEach(link=>{if(link===chosen)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
      links.forEach(link=>link.addEventListener('click',event=>{
        const target=document.getElementById(link.hash.slice(1));
        if(!target)return;
        event.preventDefault();select(link);
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
        history.replaceState(null,'',link.hash);
      }));
      if('IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{
          const entry=entries.filter(item=>item.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top)[0];
          if(entry)select(links.find(link=>link.hash==='#'+entry.target.id));
        },{rootMargin:'-12% 0px -65% 0px'});
        links.forEach(link=>{const target=document.getElementById(link.hash.slice(1));if(target)observer.observe(target);});
      }
    });
    const contactTopic=document.querySelector('#sp-contact-topic');
    if(contactTopic && !contactTopic.dataset.ssReady){
      contactTopic.dataset.ssReady='true';
      const routes=[...document.querySelectorAll('.sp-topic-route')];
      const sync=()=>routes.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.topic===contactTopic.value)));
      contactTopic.addEventListener('change',sync);
      routes.forEach(button=>button.addEventListener('click',()=>queueMicrotask(sync)));
      document.querySelectorAll('[data-close][data-topic]').forEach(button=>button.addEventListener('click',()=>queueMicrotask(sync)));
      sync();
      const result=document.querySelector('#sp-contact-form .sp-success,#sp-contact-form .sp-form-error');
      if(result)result.focus();
    }
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',init);
})();
